import {css} from "lit";

export const sbkMainNavItemStyle = css`
    div {
        height: 100%;
    }
`;
